<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                v-bind="attrs"
                v-on="on"
                :loading="buttonLoading"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="reprintReport('printReport')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545"
            ><v-icon>filter_list</v-icon>Filter<v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon></v-btn
          >
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.supplierIds"
                :items="selectedSupplierList"
                label="Supplier"
                @click="showSuppliers()"
                item-text="companyName"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="apTypeList"
                label="Select Type"
                item-text="label"
                item-value="value"
                v-model="queryParams.apType"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="accountPayableDetailList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.issueNo }}</td>
              <td>
                {{ props.item.issueDateInMilliSecond | format-ms-date }}
              </td>
              <td>{{ props.item.supplierName }}</td>
              <td>
                {{ props.item.fromPODateInMilliSecond | format-ms-date }}
              </td>
              <td>
                {{ props.item.toPODateInMilliSecond | format-ms-date }}
              </td>
              <td>{{ props.item.currencyCode }}</td>
              <td>{{ props.item.apType }}</td>
              <td>{{ props.item.rate | decFormat(6) }}</td>
              <td style="text-align: right">
                {{ props.item.amount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.discount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.payment | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <summary report> -->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">Account Payable Report</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Date From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Payment No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Rec Date
              </th>
              <th style="border: 1px solid black; text-align: center">Name</th>
              <th style="border: 1px solid black; text-align: center">
                Start Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                End Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                Currency
              </th>
              <th style="border: 1px solid black; text-align: center">Type</th>
              <th style="border: 1px solid black; text-align: center">Rate</th>
              <th style="border: 1px solid black; text-align: right">Amount</th>
              <th style="border: 1px solid black; text-align: right">
                Discount
              </th>
              <th style="border: 1px solid black; text-align: right">
                Payment (Home)
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(accountPayableReport, index) in allAccountPayableReportList"
            :key="index"
          >
            <tr
              v-for="(item, i) in accountPayableReport.accountPayableDetailList"
              :key="i"
            >
              <td style="border: 1px solid black; text-align: left">
                {{ item.issueNo }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.issueDateInMilliSecond | format-ms-date }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.supplierName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.fromPODateInMilliSecond | format-ms-date }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.toPODateInMilliSecond | format-ms-date }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.currencyCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.apType }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.rate | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.amount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.discount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.payment | decFormat(6) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: left;
                "
                colspan="8"
              >
                Sub Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ accountPayableReport.totalAmount | decFormat(6) }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ accountPayableReport.totalDiscount | decFormat(6) }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ accountPayableReport.totalPayment | decFormat(6) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Supplier list dialog -->
    <v-dialog v-model="showSupplierListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="companyName"
                label="Company Name"
                type="text"
                v-model="supplierQueryParams.companyName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchSupplier">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Supplier List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                v-model="selectedSupplierList"
                :headers="supplierHeaders"
                :items="supplierList"
                select-all
                class="elevation-1"
                :loading="showListLoading"
                :total-items="suppliertotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="supplierpagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAll"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedSupplierList"
                      multiple
                    ></v-checkbox>
                  </td>
                  <td>{{ props.item.code }}</td>
                  <td>{{ props.item.companyName }}</td>
                  <td>{{ props.item.address }}</td>
                  <td>{{ props.item.phone }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.contactPerson }}</td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setSupplier">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End dialog -->
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { accountPayableService } from "../../services/account-payable-service";
import { supplierService } from "../../services/supplier-service";
import { shopService } from "../../services/shop-service";

export default {
  name: "AccountPayableReport",
  components: {},

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showSupplierListDialog: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Purchase Reports",
        disabled: true,
      },
      {
        text: "Account Payable Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Payment No", align: "left", value: "issueNo" },
      { text: "Rec Date", align: "left", value: "issueDate" },
      { text: "Name", align: "left", value: "supplierName" },
      { text: "Start Date", align: "left", value: "fromPODate" },
      { text: "End Date", align: "left", value: "toPODate" },
      { text: "Currency", align: "left", value: "currencyCode" },
      { text: "AP Type", align: "left", value: "apType" },
      { text: "Rate", align: "left", value: "rate" },
      { text: "Amount", align: "left", value: "amount" },
      { text: "Discount", align: "left", value: "discount" },
      { text: "Payment", align: "left", value: "payment" },
    ],
    supplierHeaders: [
      { text: "Code", value: "code" },
      { text: "Company Name", value: "companyName" },
      { text: "Address", value: "address" },
      { text: "Phone No.", value: "phone" },
      { text: "Email", value: "email" },
      { text: "Contact Person", value: "contact_person" },
    ],
    shopList: [],
    statusList: [
      { label: "---ALL---", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    apTypeList: [
      { label: "----All----", value: "" },
      { label: "Purchase Payment", value: "PURCHASE_PAYMENT" },
      { label: "Purchase Return", value: "PURCHASE_RETURN" },
    ],
    supplierList: [],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "null",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      supplierIds: [],
      issueNo: "",
      status: "",
      shopId: "",
      apType: "",
    },
    accountPayableDetailList: [],
    allAccountPayableReportList: [],

    clonequeryParams: new Object(),
    supplierQueryParams: {
      companyName: "",
    },
    supplierpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0,
    },
    suppliertotalRows: 0,
    selectedSupplierList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getAccountPayableReport();
      },
      deep: true,
    },
    supplierpagination: {
      handler() {
        this.getSupplierList();
      },
      deep: true,
    },
  },

  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getShopList();
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "account-payable-report",
        query: this.queryParams,
      });
      this.getAccountPayableReport();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAccountPayableReport() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      accountPayableService
        .getAccountPayableReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.accountPayableDetailList = res.data.accountPayableDetailList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    showSuppliers() {
      // Clean query params
      this.supplierQueryParams.companyName = "";
      this.selectedSupplierList = [];
      this.queryParams.supplierIds = [];
      this.getSupplierList().then(
        (this.showSupplierListDialog = !this.showSupplierListDialog)
      );
    },

    setSupplier() {
      if (this.selectedSupplierList.length) {
        this.queryParams.supplierIds = [];
        this.selectedSupplierList.forEach((element) => {
          if (!this.queryParams.supplierIds.includes(element.id))
            this.queryParams.supplierIds.push(element.id);
        });
      }
      this.showSupplierListDialog = !this.showSupplierListDialog;
    },

    onSearchSupplier() {
      this.supplierQueryParams.page = this.supplierpagination.page;
      this.supplierQueryParams.size = this.supplierpagination.rowsPerPage;
      this.getSupplierList();
    },
    getSupplierList() {
      this.showListLoading = true;
      let order = this.supplierpagination.descending ? "desc" : "asc";
      return supplierService
        .getSupplierList(
          this.supplierQueryParams,
          this.supplierpagination.page,
          this.supplierpagination.rowsPerPage,
          this.supplierpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.supplierList = res.data.supplierList;
            this.suppliertotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    toggleAll() {
      if (this.selectedSupplierList.length) {
        this.selectedSupplierList = [];
      } else {
        this.selectedSupplierList = this.supplierList.slice();
      }
    },

    reprintReport(divName) {
      this.buttonLoading = true;
      accountPayableService
        .getAllAccountPayableReportPrint(this.clonequeryParams)
        .then((res) => {
          this.allAccountPayableReportList = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
  },
};
</script>